import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;
const SUPABASE_TARGET = process.env.REACT_APP_SUPABASE_TARGET;

function parseSupabaseUrl(url) {
  try {
    return new URL(url);
  } catch {
    throw new Error("Nieprawidlowy REACT_APP_SUPABASE_URL.");
  }
}

function isLocalSupabaseUrl(url) {
  const parsed = parseSupabaseUrl(url);
  return parsed.hostname === "localhost" || parsed.hostname === "127.0.0.1";
}

function validateSupabaseConfig() {
  if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
    throw new Error(
      "Brak konfiguracji Supabase. Ustaw REACT_APP_SUPABASE_URL i REACT_APP_SUPABASE_ANON_KEY."
    );
  }

  if (SUPABASE_TARGET !== "local" && SUPABASE_TARGET !== "production") {
    throw new Error(
      "Nieprawidlowy REACT_APP_SUPABASE_TARGET. Dozwolone wartosci: local, production."
    );
  }

  const isLocalUrl = isLocalSupabaseUrl(SUPABASE_URL);

  if (SUPABASE_TARGET === "local" && !isLocalUrl) {
    throw new Error(
      "REACT_APP_SUPABASE_TARGET=local wymaga URL wskazujacego localhost albo 127.0.0.1."
    );
  }

  if (SUPABASE_TARGET === "production" && isLocalUrl) {
    throw new Error(
      "REACT_APP_SUPABASE_TARGET=production nie moze wskazywac localhost ani 127.0.0.1."
    );
  }

  if (
    process.env.NODE_ENV === "development" &&
    !isLocalUrl &&
    SUPABASE_TARGET !== "production"
  ) {
    throw new Error(
      "W trybie development zdalny Supabase wymaga jawnego REACT_APP_SUPABASE_TARGET=production."
    );
  }
}

validateSupabaseConfig();

// ─── Klucz preferencji "Zapamiętaj mnie" ─────────────────────────────────────
// Przechowujemy w localStorage (nie w session), żeby przeżył przekierowanie
// po kliknięciu magic linka w mailu.
const REMEMBER_KEY = "klasa_remember_me";

// ─── Custom storage dla Supabase Auth ────────────────────────────────────────
// getItem   — czyta z localStorage LUB sessionStorage (gdzie jest sesja, tam zwróci)
// setItem   — zapisuje do localStorage (persistent) lub sessionStorage (session-only)
//             w zależności od flagi REMEMBER_KEY
// removeItem — czyści oba miejsca (wylogowanie zawsze musi być pełne)
const authStorage = {
  getItem(key) {
    return localStorage.getItem(key) ?? sessionStorage.getItem(key);
  },

  setItem(key, value) {
    // Domyślnie true: nowi użytkownicy + przekierowanie z magic linka
    // zachowują się tak samo jak wcześniej (localStorage).
    const remember = localStorage.getItem(REMEMBER_KEY) !== "false";
    if (remember) {
      localStorage.setItem(key, value);
      sessionStorage.removeItem(key);
    } else {
      sessionStorage.setItem(key, value);
      localStorage.removeItem(key);
    }
  },

  removeItem(key) {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  },
};

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: { storage: authStorage },
});

/**
 * Ustaw preferencję "Zapamiętaj mnie" PRZED wywołaniem signIn / signInWithMagicLink.
 * Supabase wywoła authStorage.setItem() podczas zapisu sesji —
 * flaga musi być gotowa wcześniej.
 */
export function setRememberPreference(remember) {
  localStorage.setItem(REMEMBER_KEY, remember ? "true" : "false");
}
